// src/utils/surveyValidation.js

/**
 * Scans sdataGroup and returns an array of warnings/errors:
 * - Duplicate Question IDs (Question_number)
 * - Duplicate codes (row/column/statement index) within a single question
 *
 * Each issue: { itemId, type, message, key }
 * `key` is the actual sdataGroup key (may differ from Question_number),
 * used for navigation back to the question.
 */
export function validateSurvey(sdataGroup = {}) {
  const issues = [];

  // ---- 1. Duplicate Question IDs ----
  const idMap = {};
  Object.entries(sdataGroup).forEach(([key, q]) => {
    const qid = q?.Question_number || key;
    if (!idMap[qid]) idMap[qid] = [];
    idMap[qid].push(key);
  });

  Object.entries(idMap).forEach(([qid, keys]) => {
    if (keys.length > 1) {
      // one error entry per duplicate occurrence, matches screenshot's repeated-row style
      keys.forEach((key) => {
        issues.push({
          itemId: qid,
          type: "Error",
          message: `The question id '${qid}' was not unique.`,
          key,
        });
      });
    }
  });

  // ---- 2. Duplicate codes within rows / columns / statements ----
  Object.entries(sdataGroup).forEach(([key, q]) => {
    const qid = q?.Question_number || key;

    ["rows", "columns", "statements"].forEach((listType) => {
      const items = q?.[listType];
      if (!Array.isArray(items)) return;

      const codeGroups = {};
      items.forEach((item) => {
        const code = item?.index ?? item?.id;
        if (code === undefined || code === null || code === "") return;
        if (!codeGroups[code]) codeGroups[code] = 0;
        codeGroups[code] += 1;
      });

      Object.entries(codeGroups).forEach(([code, count]) => {
        if (count > 1) {
          // repeat once per duplicate occurrence (mirrors screenshot: same error listed per repeat)
          for (let i = 0; i < count; i++) {
            issues.push({
              itemId: qid,
              type: "Error",
              message: `The code '${code}' was not unique.`,
              key,
            });
          }
        }
      });
    });
  });

  return issues;
}